export function scrollLayoutContentToTop() {
  const element = document.getElementById('element-scroll-to');

  if (!element) {
    return;
  }

  element.scrollIntoView();
}
